import React from 'react';
import '../../styles/styles.css';

export default function simhachalam() {
  return (
    <div class="container mt-4">
        <div class="row">
            {/* Left Large Image Box */}
            <div class="col-md-4 box1">
            <img src="/images/Simhachalam.jpeg" alt="Simhadri Appanna Swamy" />    
            </div>

            {/* Right Information Boxes */}
            <div class="col-md-8">
                <div class="Reg-box2">
                    <p><strong>Important Dates in Simhachalam to visit<br />
    Chandana Utsavam : 26th April, 2026<br />    
    <br /></strong></p>     </div>
    
        </div>

        {/* Bottom Full Width Description Box */}
        <div class="row mt-3">
            <div class="col-12 Desc-box3">
             <p>Simhachalam Temple is located in Vishakhapatnam (Vizag) of Andhra Pradesh, dedicated to Lord Narasimha Swamy, an incarnation of Lord Vishnu. The temple name is derived from "Simha"- a lion and "Achala"- a hill. The deity is in the tribhangi posture, with the head of a lion on a human torso. The temple has 16-pillared Natyamandapa and 96-pillared Kalyanamandapa. The idol is covered with sandalwood throughout the year and is revealed only once a year which is celebrated as Chandanotsavam. According to the legend of Simhachalam, Hiranyaksha, the brother of Hiranya-Kasyapa intended to disturb the peace on earth. Lord Vishnu assumed the incarnation of Boar (Varaha Avatara) and destroyed him, thus rescuing the earth.</p>
            </div>
        </div>
    </div>
    </div>
  )
}
